<template>
    <router-view></router-view>    
</template>

<script>
    export default {
        name: "guest-wrapper"
    }
</script>